import { useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getMunByStartsWith } from "../helpers";

const colorBase = "#c3e67e";
const colorSelected = "#ff9d42";
const resetMap = () => {
  for (let i = 0; i < 106; i++) {
    document.getElementsByTagName("path")[i].style.fill = colorBase;
  }
};

const BtnLetters = () => {
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState("");
  const [mpios, setMpios] = useState([]);
  const [buttons] = useState([
    "a",
    "b",
    "c",
    "d",
    "e",
    "h",
    "i",
    "k",
    "m",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "x",
    "y",
  ]);

  const onClose = () => setShow(false);
  const onShow = () => setShow(true);

  const onClick = (letter) => {
    resetMap();

    const getMuni = getMunByStartsWith(letter);
    setMpios(getMuni);

    getMuni.forEach((muni) => {
      document.getElementById(muni.id).style.fill = colorSelected;
      if (window.screen.width < 800) {
        setSelected(letter);
        onShow();
      }
    });

    // switch(letter){
    //   case 'a':
    //     document.getElementById('abala').style.fill = colorSelected;
    //     document.getElementById('acanceh').style.fill = colorSelected;
    //     document.getElementById('akil').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('a');
    //       onShow();
    //     }
    //     break;
    //   case 'b':
    //     document.getElementById('baca').style.fill = colorSelected;
    //     document.getElementById('bokoba').style.fill = colorSelected;
    //     document.getElementById('buctzotz').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('b');
    //       onShow();
    //     }
    //     break;
    //   case 'c':
    //     document.getElementById('cacalchen').style.fill = colorSelected;
    //     document.getElementById('calotmul').style.fill = colorSelected;
    //     document.getElementById('cansahcab').style.fill = colorSelected;
    //     document.getElementById('cantamayec').style.fill = colorSelected;
    //     document.getElementById('celestun').style.fill = colorSelected;
    //     document.getElementById('cenotillo').style.fill = colorSelected;
    //     document.getElementById('conkal').style.fill = colorSelected;
    //     document.getElementById('cuncunul').style.fill = colorSelected;
    //     document.getElementById('cuzama').style.fill = colorSelected;
    //     document.getElementById('chacsinkin').style.fill = colorSelected;
    //     document.getElementById('chankom').style.fill = colorSelected;
    //     document.getElementById('chapab').style.fill = colorSelected;
    //     document.getElementById('chemax').style.fill = colorSelected;
    //     document.getElementById('chicxulub-pueblo').style.fill = colorSelected;
    //     document.getElementById('chichimila').style.fill = colorSelected;
    //     document.getElementById('chikindzonot').style.fill = colorSelected;
    //     document.getElementById('chochola').style.fill = colorSelected;
    //     document.getElementById('chumayel').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('c');
    //       onShow();
    //     }
    //     break;
    //   case 'd':
    //     document.getElementById('dzan').style.fill = colorSelected;
    //     document.getElementById('dzemul').style.fill = colorSelected;
    //     document.getElementById('dzidzantun').style.fill = colorSelected;
    //     document.getElementById('dzilam-de-bravo').style.fill = colorSelected;
    //     document.getElementById('dzilam-gonzalez').style.fill = colorSelected;
    //     document.getElementById('dzitas').style.fill = colorSelected;
    //     document.getElementById('dzoncauich').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('d');
    //       onShow();
    //     }
    //     break;
    //   case 'e':
    //     document.getElementById('espita').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('e');
    //       onShow();
    //     }
    //     break;
    //   case 'h':
    //     document.getElementById('halacho').style.fill = colorSelected;
    //     document.getElementById('hocaba').style.fill = colorSelected;
    //     document.getElementById('hoctun').style.fill = colorSelected;
    //     document.getElementById('homun').style.fill = colorSelected;
    //     document.getElementById('huhi').style.fill = colorSelected;
    //     document.getElementById('hunucma').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('h');
    //       onShow();
    //     }
    //     break;
    //   case 'i':
    //     document.getElementById('ixil').style.fill = colorSelected;
    //     document.getElementById('izamal').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('i');
    //       onShow();
    //     }
    //     break;
    //   case 'k':
    //     document.getElementById('kanasin').style.fill = colorSelected;
    //     document.getElementById('kantunil').style.fill = colorSelected;
    //     document.getElementById('kaua').style.fill = colorSelected;
    //     document.getElementById('kinchil').style.fill = colorSelected;
    //     document.getElementById('kopoma').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('k');
    //       onShow();
    //     }
    //     break;
    //   case 'm':
    //     document.getElementById('mama').style.fill = colorSelected;
    //     document.getElementById('mani').style.fill = colorSelected;
    //     document.getElementById('maxcanu').style.fill = colorSelected;
    //     document.getElementById('mayapan').style.fill = colorSelected;
    //     document.getElementById('merida').style.fill = colorSelected;
    //     document.getElementById('mococha').style.fill = colorSelected;
    //     document.getElementById('motul').style.fill = colorSelected;
    //     document.getElementById('muna').style.fill = colorSelected;
    //     document.getElementById('muxupip').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('m');
    //       onShow();
    //     }
    //     break;
    //   case 'o':
    //     document.getElementById('opichen').style.fill = colorSelected;
    //     document.getElementById('oxkutzcab').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('o');
    //       onShow();
    //     }
    //     break;
    //   case 'p':
    //     document.getElementById('panaba').style.fill = colorSelected;
    //     document.getElementById('peto').style.fill = colorSelected;
    //     document.getElementById('progreso').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('p');
    //       onShow();
    //     }
    //     break;
    //   case 'q':
    //     document.getElementById('quintana-roo').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('q');
    //       onShow();
    //     }
    //     break;
    //   case 'r':
    //     document.getElementById('rio-lagartos').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('r');
    //       onShow();
    //     }
    //     break;
    //   case 's':
    //     document.getElementById('sacalum').style.fill = colorSelected;
    //     document.getElementById('samahil').style.fill = colorSelected;
    //     document.getElementById('sanahcat').style.fill = colorSelected;
    //     document.getElementById('san-felipe').style.fill = colorSelected;
    //     document.getElementById('santa-elena').style.fill = colorSelected;
    //     document.getElementById('seye').style.fill = colorSelected;
    //     document.getElementById('sinanche').style.fill = colorSelected;
    //     document.getElementById('sotuta').style.fill = colorSelected;
    //     document.getElementById('sucila').style.fill = colorSelected;
    //     document.getElementById('sudzal').style.fill = colorSelected;
    //     document.getElementById('suma').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('s');
    //       onShow();
    //     }
    //     break;
    //   case 't':
    //     document.getElementById('tahdziu').style.fill = colorSelected;
    //     document.getElementById('tahmek').style.fill = colorSelected;
    //     document.getElementById('teabo').style.fill = colorSelected;
    //     document.getElementById('tecoh').style.fill = colorSelected;
    //     document.getElementById('tekal-de-venegas').style.fill = colorSelected;
    //     document.getElementById('tekanto').style.fill = colorSelected;
    //     document.getElementById('tekax').style.fill = colorSelected;
    //     document.getElementById('tekit').style.fill = colorSelected;
    //     document.getElementById('tekom').style.fill = colorSelected;
    //     document.getElementById('telchac-pueblo').style.fill = colorSelected;
    //     document.getElementById('telchac-puerto').style.fill = colorSelected;
    //     document.getElementById('temax').style.fill = colorSelected;
    //     document.getElementById('temozon').style.fill = colorSelected;
    //     document.getElementById('tepakan').style.fill = colorSelected;
    //     document.getElementById('tetiz').style.fill = colorSelected;
    //     document.getElementById('teya').style.fill = colorSelected;
    //     document.getElementById('ticul').style.fill = colorSelected;
    //     document.getElementById('timucuy').style.fill = colorSelected;
    //     document.getElementById('tinum').style.fill = colorSelected;
    //     document.getElementById('tixcacalcupul').style.fill = colorSelected;
    //     document.getElementById('tixkokob').style.fill = colorSelected;
    //     document.getElementById('tixmehuac').style.fill = colorSelected;
    //     document.getElementById('tixpehual').style.fill = colorSelected;
    //     document.getElementById('tizimin').style.fill = colorSelected;
    //     document.getElementById('tunkas').style.fill = colorSelected;
    //     document.getElementById('tzucacab').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('t');
    //       onShow();
    //     }
    //     break;
    //   case 'u':
    //     document.getElementById('uayma').style.fill = colorSelected;
    //     document.getElementById('ucu').style.fill = colorSelected;
    //     document.getElementById('uman').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('u');
    //       onShow();
    //     }
    //     break;
    //   case 'v':
    //     document.getElementById('valladolid').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('v');
    //       onShow();
    //     }
    //     break;
    //   case 'x':
    //     document.getElementById('xocchel').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('x');
    //       onShow();
    //     }
    //     break;
    //   case 'y':
    //     document.getElementById('yaxcaba').style.fill = colorSelected;
    //     document.getElementById('yaxkukul').style.fill = colorSelected;
    //     document.getElementById('yobain').style.fill = colorSelected;
    //     if(window.screen.width < 800){
    //       setSelected('y');
    //       onShow();
    //     }
    //     break;
    //   default:
    //     alert('No implementado');
    //     break
    // }
  };

  return (
    <>
      <div id="section-buttons" className="row">
        <h3 className="mb-4 text-center">
          Selecciona la inicial del nombre de tu municipio:
        </h3>
        <div className="buttons-letter justify-content-center">
          {buttons.map((btn, index) => (
            <div key={index}>
              <button
                className="btn btn-info text-white"
                onClick={() => onClick(btn)}
              >
                {btn.toUpperCase()}
              </button>
            </div>
          ))}
        </div>
      </div>
      <Modal show={show} onHide={onClose} mpios={mpios} size="sm">
        <Modal.Header closeButton>
          <Modal.Title>Selecciona un municipio:</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-center">
            <ul>
              {mpios.map((mpio) => (
                <li key={mpio.id}>
                  <Link to={process.env.PUBLIC_URL + "/" + mpio.id}>
                    {mpio.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BtnLetters;
